import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { AnalysisResultsTextCommon } from '@sleipai/sleip-models';
import {
  State,
  selectAllAnalysisResultsAdapter,
  analysisResultsTextsFeatureKey,
} from '../reducers/analysis-results-text.reducer';

export const selectAnalysisResultsTextStoreState = createFeatureSelector<State>(
  analysisResultsTextsFeatureKey
);

export const isLoaded = (state: State): boolean => state.loaded;
export const isLoading = (state: State): boolean => state.loading;
export const analysisResultsTextError = (state: State): string | null =>
  state.error;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectAnalysisResultsTextStoreState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectAnalysisResultsTextStoreState,
  isLoaded
);

export const selectAnalysisResultsTextError: MemoizedSelector<
  object,
  string | null
> = createSelector(
  selectAnalysisResultsTextStoreState,
  analysisResultsTextError
);

export const selectAllAnalysisResultsText = createSelector(
  selectAnalysisResultsTextStoreState,
  selectAllAnalysisResultsAdapter
);

export const selectSingleAnalysisResultsText = (id: string) =>
  createSelector(
    selectAllAnalysisResultsText,
    (analysisResultsTexts: AnalysisResultsTextCommon[]) => {
      if (analysisResultsTexts) {
        return analysisResultsTexts.find((analysisResultsText) => analysisResultsText.id === id);
      } else {
        return null;
      }
    }
  );

export const selectAnalysisResultsTextsByIds = (ids: string[]) => {
  return createSelector(
    selectAllAnalysisResultsText,
    (analysisResultsTexts: AnalysisResultsTextCommon[]) => {
      if (analysisResultsTexts) {
        return analysisResultsTexts.filter(
          ({ id }) => ids.indexOf(id ?? '') != -1
        );
      } else {
        return null;
      }
    }
  );
};
